import { ALL_NAMED_GRAPH_IRI } from 'src/templates/queries/iris';

export interface ExplorerLinkProps {
  database: string;
  connectionDashboard: string;
  hasReasoning: boolean;
  hasVirtualGraphs: boolean;
  model: string;
}

export const getExplorerLink = ({
  database,
  connectionDashboard,
  hasReasoning,
  hasVirtualGraphs,
  model,
}: ExplorerLinkProps) => {
  const explorer = 'explorer';

  const queryParams = [
    `db=${encodeURIComponent(database)}`,
    `model=${encodeURIComponent(model)}`,
  ];

  if (hasVirtualGraphs) {
    queryParams.push(`graph=${encodeURIComponent(ALL_NAMED_GRAPH_IRI)}`);
  }
  if (hasReasoning) {
    queryParams.push('reasoning');
  }

  const queryString = queryParams.join('&');
  const url = `${connectionDashboard}${explorer}/#/graph?${queryString}`;

  return url;
};
